import i18n, { required } from "@/locale/locale.config";
import { QueryParams } from "@/models/query-params.model";
import { User, UserConfigs } from "@/models/user.model";
import { UsersRest } from "@/services/rest/users.rest";
import { validateImageResolution } from "@/utils/regex.util";
import { getUserFromStorage, storeUser } from "@/utils/user-store.util";
import { helpers } from "@vuelidate/validators";
import { BehaviorSubject, Observable, Subject, take } from "rxjs";

export class EditUserService {
  constructor(private _user = new UsersRest()) {}

  private profile$: BehaviorSubject<any> = new BehaviorSubject({});
  profile: Observable<any> = this.profile$.asObservable();

  private avatars$: Subject<any> = new Subject();
  avatars: Observable<any> = this.avatars$.asObservable();

  private configs$: Subject<any> = new Subject();
  configs: Observable<any> = this.configs$.asObservable();

  getProfileUser(): void {
    this._user
      .getProfileUser()
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.profile$.next(response);
        },
      });
  }

  getAllAvatars(): void {
    const params: QueryParams = new QueryParams();
    params.size = 100;
    this._user.getAllAvatars(params).subscribe({
      next: (response) => {
        this.avatars$.next(response);
      },
    });
  }

  getUserConfigurations(): void {
    this._user
      .getUserConfigurations()
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.configs$.next(response);
        },
      });
  }

  stockNewUser(user: any): void {
    const newUser = new User();
    newUser.id = user?.id;
    newUser.userName = user?.name;
    newUser.role = user?.role;
    newUser.accessToken = getUserFromStorage()?.accessToken;
    newUser.photoProfile = user?.photoProfile?.path;
    newUser.userConfiguration = getUserFromStorage()?.userConfiguration;
    storeUser(newUser);
  }

  saveConfigs(userConfiguration: UserConfigs): void {
    const old = getUserFromStorage();
    var attention = { userConfiguration };
    storeUser({ ...old, ...attention });
  }

  themeRules = {
    subdomain: { required: required },
    logo: {
      required: required,
      type: helpers.withMessage(
        i18n.global.t("validations.validImage"),
        (value: File[]) => {
          return value.every((file: any) =>
            file.image ? true : file.type === "image/svg+xml"
          );
        }
      ),
      resolution: validateImageResolution(),
    },
    partners: {
      type: helpers.withMessage(
        i18n.global.t("validations.validImage"),
        (value: File[]) => {
          return value.every((file: any) =>
            file.image ? true : file.type === "image/svg+xml"
          );
        }
      ),
      resolution: validateImageResolution(),
    },
  };
}
